(() => {
  const key='filter.v.availability';
  const normalizeParams=value=>{const p=new URLSearchParams(value);if(!p.has(key))p.set(key,'1');return p.toString();};
  const showSoldOut=()=>new URLSearchParams(location.search).getAll(key).includes('0');
  const refresh=()=>document.querySelectorAll('[data-stock-show-sold-out]').forEach(c=>{c.checked=showSoldOut();});
  const productVisible=doc=>{
    const selection=new URLSearchParams(location.search).getAll(key);
    const available=doc.variants.some(v=>v.available);
    if(selection.includes('0'))return selection.includes('1')||doc.variants.some(v=>!v.available);
    return available;
  };
  const autumnVariant=doc=>{
    if(!/garn/i.test(doc.type||'')||/kit/i.test(doc.type||''))return null;
    const hasAvailable=doc.variants.some(v=>v.available);
    const candidates=doc.variants.filter(v=>(!hasAvailable||v.available)&&v.image&&!/ruta|swatch/i.test(v.image));
    const score=v=>{
      const s=String(v.title||'').toLowerCase();
      const colour=/rost|terracotta|tegel|senap|vinröd|burgundy|bordeaux|plommon|skog|oliv|orange|ockra|koppar|pumpa|mustard|rust|autumn/.test(s)?80:/gul|röd|grön|lila|rosa|turkos|blå|aprikos|petrol|cerise|koral|yellow|red|green|purple|pink|blue/.test(s)?30:0;
      return (v.available?1000:0)+(/svart|black/.test(s)?-30:colour)+(Number(v.id)%19||0);
    };
    return candidates.sort((a,b)=>score(b)-score(a))[0]||null;
  };
  window.KickisStock={normalizeParams,showSoldOut,refresh,productVisible,autumnVariant};
  const url=new URL(location.href);
  const listing=/\/collections\/[^/]+\/?$/.test(url.pathname)||(/\/search\/?$/.test(url.pathname)&&url.searchParams.has('q'));
  if(listing&&!url.searchParams.has(key)&&!url.searchParams.has('section_id')){
    url.searchParams.set(key,'1');location.replace(url.href);return;
  }
  document.addEventListener('change',event=>{
    if(!event.target.matches('[data-stock-show-sold-out]'))return;
    const dest=new URL(location.href);dest.searchParams.delete('page');dest.searchParams.delete(key);
    dest.searchParams.append(key,'1');if(event.target.checked)dest.searchParams.append(key,'0');
    location.assign(dest.href);
  });
  window.addEventListener('popstate',refresh);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
})();
